// extracted by mini-css-extract-plugin
export default {"container":"Tema_container__TF5lI","titulo":"Tema_titulo__vmd-+"};